import { render, staticRenderFns } from "./BaseArrowDownIcon.vue?vue&type=template&id=558283b8"
import script from "./BaseArrowDownIcon.vue?vue&type=script&lang=js"
export * from "./BaseArrowDownIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports